import { customerApi } from "../utils/apiConfig";

export const updateAdminSettings = (data, token) =>
  customerApi.post("/updateAdminSettings", data, {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });

export const getAdminSettings = (token) =>
  customerApi.get("/getAdminSettings", {
    headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
  });
